import { render, staticRenderFns } from "./ActivityMixin.vue?vue&type=template&id=83caeb64&scoped=true&"
import script from "./ActivityMixin.vue?vue&type=script&lang=ts&"
export * from "./ActivityMixin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83caeb64",
  null
  
)

export default component.exports